function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Layout, Menu, Tooltip, Spin, PaperIcon } from '@nackle/paper';
const {
  SubMenu,
  ItemGroup,
  Item
} = Menu;
const {
  Sider
} = Layout;
import { getString } from '@nackle/intl-tools';
import NavigationService from './navigation-service';
import './nackle-menu.less';
class NackleMenu extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      navigationType: '',
      navigationLoaded: false,
      navigationData: {},
      cmxBundleLoaded: false,
      defaultOpenKeys: [],
      defaultSelectedKeys: [],
      selectedKeys: []
    });
    _defineProperty(this, "handleNavigation", () => {
      const {
        navigationData
      } = this.state;
      if (navigationData && navigationData.id) {
        const {
          defaultOpenKeys,
          defaultSelectedKeys
        } = this.getDefaultKeys(navigationData);
        this.setState((state, props) => ({
          ...state,
          defaultOpenKeys,
          selectedKeys: defaultSelectedKeys
        }));
      }
    });
    _defineProperty(this, "loadNavigation", async () => {
      const {
        type,
        auth
      } = this.props;
      const navigationService = new NavigationService(auth.state);
      const data = await navigationService.getMenu(type);
      const {
        defaultOpenKeys,
        defaultSelectedKeys
      } = this.getDefaultKeys(data);
      this.setState((state, props) => ({
        navigationData: data,
        navigationLoaded: true,
        defaultOpenKeys,
        defaultSelectedKeys
      }));
    });
    _defineProperty(this, "getDefaultKeys", navigationData => {
      if (!navigationData || !navigationData.sections) {
        return [];
      }
      const defaultOpenKeys = [];
      const defaultSelectedKeys = [];
      const doesUrlStartWithWindowLocation = itemUrl => {
        return itemUrl.indexOf(window.location.origin) === 0;
      };
      const locationUrlParts = window.location.href.split('//')[1].split('#')[0].split('/');
      const doesUrlMatchWindowLocation = itemUrl => {
        const itemUrlParts = itemUrl.split('//')[1].split('#')[0].split('/');
        if (itemUrlParts.length !== locationUrlParts.length) {
          return false;
        }
        for (let i = 0; i < itemUrlParts.length; i++) {
          if (itemUrlParts[i] !== locationUrlParts[i] && itemUrlParts[i] !== '${companyId}') {
            return false;
          }
        }
        return true;
      };
      const addKeys = (parentKeys, sections) => {
        sections.forEach(section => {
          section.items.forEach(item => {
            if (item.url && doesUrlStartWithWindowLocation(item.url)) {
              item.subMenu && !defaultOpenKeys.includes(item.id) && defaultOpenKeys.push(item.id);
              parentKeys.forEach(key => {
                !defaultOpenKeys.includes(key) && defaultOpenKeys.push(key);
              });
              !defaultOpenKeys.includes(section.id) && defaultOpenKeys.push(section.id);
            }
            if (item.url && doesUrlMatchWindowLocation(item.url)) {
              !defaultSelectedKeys.includes(item.id) && defaultSelectedKeys.push(item.id);
            }
            if (item.subMenu) {
              addKeys([...parentKeys, section.id], item.subMenu.sections);
            }
          });
        });
      };
      addKeys([], navigationData.sections);
      return {
        defaultOpenKeys,
        defaultSelectedKeys
      };
    });
  }
  componentDidMount() {
    this.loadNavigation();
    addEventListener('popstate', this.handleNavigation);
  }
  render() {
    const {
      auth,
      cmxBundleLoaded,
      tooltipColor,
      theme,
      mode,
      width,
      collapsible,
      onItemClick
    } = this.props;
    const {
      navigationLoaded,
      navigationData,
      defaultOpenKeys,
      defaultSelectedKeys,
      selectedKeys
    } = this.state;
    const loaded = cmxBundleLoaded && navigationLoaded;
    return /*#__PURE__*/React.createElement(Sider, {
      className: classNames('nackle-menu', {
        'is-loaded': loaded
      }),
      collapsible: collapsible,
      width: width
    }, !loaded ? /*#__PURE__*/React.createElement("div", {
      className: "nackle-menu-activity-indicator"
    }, /*#__PURE__*/React.createElement(Spin, {
      size: "large"
    })) : /*#__PURE__*/React.createElement(Menu, {
      theme: theme,
      mode: mode,
      selectedKeys: selectedKeys && selectedKeys.length > 0 ? selectedKeys : undefined,
      defaultOpenKeys: defaultOpenKeys,
      defaultSelectedKeys: defaultSelectedKeys
    }, navigationData.sections.map(section => /*#__PURE__*/React.createElement(NackleMenuItem, {
      key: section.id,
      item: section,
      tooltipColor: tooltipColor,
      theme: theme,
      onItemClick: onItemClick,
      companyId: auth.state.claims.company_id
    }))));
  }
}
_defineProperty(NackleMenu, "propTypes", {
  type: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['dark', 'light']).isRequired,
  width: PropTypes.number.isRequired,
  collapsible: PropTypes.bool.isRequired,
  auth: PropTypes.object.isRequired,
  cmxBundleLoaded: PropTypes.bool.isRequired,
  tooltipColor: PropTypes.string.isRequired,
  onItemClick: PropTypes.func
});
_defineProperty(NackleMenu, "defaultProps", {
  type: 'STUDIO',
  theme: 'dark',
  mode: 'inline',
  tooltipColor: 'geekblue',
  width: 256,
  collapsible: true
});
class NackleMenuItem extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleClick", async () => {
      const {
        item,
        onItemClick,
        companyId
      } = this.props;
      const url = item.url ? item.url.replace('${companyId}', companyId) : undefined;
      let preventDefault = false;
      if (typeof onItemClick === 'function') {
        await onItemClick({
          companyId,
          item,
          url,
          preventDefault: () => {
            preventDefault = true;
          }
        });
      }
      if (!url || preventDefault) {
        return;
      }
      if (url.indexOf(window.location.origin) === 0) {
        const title = item.labelKey ? getString(item.labelKey) : undefined;
        const pathname = url.substring(window.location.origin.length);
        history.pushState(undefined, title, pathname);
        window.dispatchEvent(new Event('popstate'));
      } else {
        window.location = url;
      }
    });
  }
  render() {
    const {
      item,
      theme,
      tooltipColor,
      onItemClick,
      companyId,
      ...props
    } = this.props;
    const {
      id,
      iconName,
      labelKey,
      descriptionKey,
      subMenu,
      items
    } = item;
    const labelText = labelKey ? getString(labelKey) : undefined;
    const tooltipText = descriptionKey ? getString(descriptionKey) : undefined;
    if (subMenu || items) {
      return /*#__PURE__*/React.createElement(SubMenu, _extends({
        key: id,
        icon: iconName && /*#__PURE__*/React.createElement(PaperIcon, {
          icon: iconName,
          className: "menu-icon"
        }),
        title: /*#__PURE__*/React.createElement(Tooltip, {
          placement: "rightTop",
          title: tooltipText,
          mouseEnterDelay: 2,
          color: tooltipColor
        }, /*#__PURE__*/React.createElement("span", null, labelText))
      }, props), /*#__PURE__*/React.createElement(ItemGroup, {
        title: labelText,
        className: classNames('nackle-menu-collapsed-header', theme)
      }), subMenu && subMenu.sections.map(section => {
        const sectionLabelText = section.labelKey ? getString(section.labelKey) : undefined;
        const sectionTooltipText = section.descriptionKey ? getString(section.descriptionKey) : undefined;
        return /*#__PURE__*/React.createElement(Tooltip, {
          placement: "rightTop",
          title: sectionTooltipText,
          mouseEnterDelay: 2,
          color: tooltipColor
        }, /*#__PURE__*/React.createElement(ItemGroup, {
          id: section.id,
          title: sectionLabelText
        }, section.items.map(subMenuItem => /*#__PURE__*/React.createElement(NackleMenuItem, {
          key: subMenuItem.id,
          item: subMenuItem,
          tooltipColor: tooltipColor,
          onItemClick: onItemClick,
          companyId: companyId
        }))));
      }), items && items.map(subMenuItem => /*#__PURE__*/React.createElement(NackleMenuItem, {
        key: subMenuItem.id,
        item: subMenuItem,
        tooltipColor: tooltipColor,
        onItemClick: onItemClick,
        companyId: companyId
      })));
    }
    return /*#__PURE__*/React.createElement(Item, _extends({
      key: id
    }, props, {
      icon: iconName && /*#__PURE__*/React.createElement(PaperIcon, {
        icon: iconName,
        className: "menu-icon"
      }),
      onClick: this.handleClick
    }), /*#__PURE__*/React.createElement(Tooltip, {
      placement: "rightTop",
      title: tooltipText,
      mouseEnterDelay: 2,
      color: tooltipColor
    }, /*#__PURE__*/React.createElement("span", null, labelText)));
  }
}
export default NackleMenu;
//# sourceMappingURL=nackle-menu.js.map